<template>
	<div class="d-flex flex-row align-center justify-space-between">
		<p class="mb-0 caption"><b>Adjuntos</b></p>

		<v-menu
			v-model="menuFiles"
			offset-y
			:close-on-content-click="false"
			min-width="450px"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					icon
					dark
					small
					color="#2D4B95"
					v-bind="attrs"
					v-on="on"
				>
					<v-icon dark small>mdi-file-eye-outline</v-icon>
				</v-btn>
			</template>
			<div class="white py-2 px-4">
				<div class="d-flex align-center justify-space-between gray lighten-4 px-2">
					<p class="mb-0 font-weight-bold caption">Adjuntos del Estado de Pago (Nº{{item.originalIndex + 1}})</p>
					<v-btn
						icon
						small
						@click="menuFiles = false"
					>
						<v-icon small>mdi-close</v-icon>
					</v-btn>
				</div>
				<v-divider class="my-1"></v-divider>
				<div v-if="item.files && item.files.length > 0" class="mb-3">
					<div class="d-flex flex-row align-center justify-space-between mb-2" style="flex-wrap: wrap; gap: 8px;">
						<div class="d-flex align-center">
							<v-icon x-small class="mr-1" color="#5E85EF">mdi-paperclip</v-icon>
							<span class="font-weight-bold text--secondary caption">Adjuntos ({{ item.files.length }})</span>
						</div>
						<v-btn
							v-if="item.files.length > 1"
							color="#5E85EF"
							outlined
							x-small
							height="24"
							:loading="loadingFilePath"
							@click="downloadAttachments(item.files)"
							class="caption"
						>
							<v-icon x-small>mdi-download</v-icon>
							<span class="ml-1" style="font-size: 0.65rem;">Descargar Todo</span>
						</v-btn>
					</div>
					<div class="d-flex flex-row" style="gap: 8px; flex-wrap: wrap;">
						<AttachmentPreviewButton
							v-for="(file, fileIndex) in item.files"
							:key="`preview-${fileIndex}`"
							:attachment="normalizeAttachment(file)"
							:loading="loadingFilePath"
							compact
							@preview="previewAttachment"
						/>
						<v-tooltip bottom v-for="(file, fileIndex) in item.files" :key="fileIndex">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									:href="file.url"
									target="_blank"
									text
									x-small
									class="file-btn"
									style="background-color: #e3ebff;"
									height="auto"
									v-bind="attrs"
									v-on="on"
								>
									<div class="d-flex flex-column py-1">
										<div class="mb-1 text--secondary" style="font-size: 8px;"><strong>{{ file.user.name }}</strong></div>
										<div class="d-flex justify-start align-center">
											<v-icon x-small class="mr-1">{{ file.mime_type && file.mime_type.includes('image') ? 'mdi-image' : 'mdi-file-document' }}</v-icon>
											<span class="file-name-truncate" style="max-width: 120px; font-size: 10px;">{{ file.name }}</span>
											<v-icon x-small class="ml-1">mdi-open-in-new</v-icon>
										</div>
									</div>
								</v-btn>
							</template>
							<div>
								<p class="mb-0 caption"><b>Nombre Archivo:</b> {{ file.name }}</p>
								<p class="mb-0 caption"><b>Subido por:</b> {{ file.user.name }} | {{ file.user.email }}</p>
								<p class="mb-0 caption"><b>Fecha de subida:</b> {{ file.created_at | toDate }}</p>
							</div>
						</v-tooltip>
					</div>
				</div>
				<div v-if="!item.files || (item.files.length === 0 && files_new.length === 0)" class="text-center py-4">
					<v-icon color="text--secondary" size="32">mdi-paperclip-off</v-icon>
					<p class="mb-0 caption text--secondary mt-2">No hay archivos adjuntos</p>
				</div>
				<div v-if="files_new.length > 0" class="mb-3">
					<div class="caption font-weight-bold mb-2">Archivos por cargar:</div>
					<div v-for="(file, index) in files_new" :key="index" class="d-flex align-center mb-2 justify-space-between">
						<div class="d-flex align-center flex-grow-1 min-width-0">
							<v-icon x-small class="mr-2" color="#5E85EF">{{ file.type.includes('image') ? 'mdi-image' : 'mdi-file-document' }}</v-icon>
							<span class="caption" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ file.name }}</span>
						</div>
						<v-btn
							icon
							x-small
							class="ml-2"
							@click="removeAttachment(index)"
						>
							<v-icon x-small>mdi-close</v-icon>
						</v-btn>
					</div>
				</div>

				<v-divider class="my-2"></v-divider>

				<div class="py-1 d-flex justify-space-between" style="gap: 5px;">
					<v-btn
						x-small
						color="#2D4B95"
						text
						@click="onButtonClick"
					>
						<v-icon x-small class="mr-1">mdi-plus</v-icon>
						Agregar Archivo
					</v-btn>
					<div class="d-flex" style="gap: 5px;"
							v-if="files_new.length > 0">
						<v-btn
							x-small
							text
							@click="cancelForm"
						>
							Cancelar
						</v-btn>
						<v-btn
							x-small
							color="#2D4B95"
							dark
							:loading="loading"
							@click="sendFiles"
						>
							Confirmar
						</v-btn>
					</div>
				</div>

				<input
					ref="uploader"
					class="d-none"
					type="file"
					:accept="acceptedFileTypes"
					@change="onFileChanged"
				>
			</div>
		</v-menu>
		<GlobalFileViewer
			:media-items="viewerMediaItems"
			:media-index="viewerMediaIndex"
			:document-item="viewerDocumentItem"
			:forge-item="viewerForgeItem"
			@close="closeAttachmentViewer"
			@minimize-file="minimizeAttachmentViewer"
			@open-morphable="openItemMorphable"
			@error="onViewerError"
			@load="onViewerLoad"
		/>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import {getZippedFiles} from '@/helpers/api/fileUploads'
import {getParentElement} from '@/helpers/api/general'
import GlobalFileViewer from '@/components/Globals/Helpers/GlobalFileViewer'
import AttachmentPreviewButton from '@/components/Globals/Helpers/AttachmentPreviewButton'
import {normalizeAttachmentForPreview, toMediaViewerItem} from '@/helpers/attachmentPreview'

export default {
	name: 'AGPFiles',
	components: { GlobalFileViewer, AttachmentPreviewButton },
	props: {
		item: {
			type: Object,
			required: true
		}
	},
	computed: {
		acceptedFileTypes() {
			return [
				'application/pdf',
				'image/jpeg',
				'image/png',
			].join(',');
		},
	},
	data() {
		return {
			menuFiles: false,
			loading: false,
			loadingFilePath: false,
			files_new: [],
			viewerMediaItems: [],
			viewerMediaIndex: null,
			viewerDocumentItem: null,
			viewerForgeItem: null
		}
	},
	watch: {
		menuFiles(newVal) {
			if (!newVal) {
				this.cancelForm()
			}
		}
	},
	methods: {
		normalizeAttachment(attachment) {
			return normalizeAttachmentForPreview(attachment)
		},
		previewAttachment(attachment) {
			const normalized = normalizeAttachmentForPreview(attachment)
			this.closeAttachmentViewer()

			if (normalized?.pathmedia?.path) {
				const mediaItem = toMediaViewerItem(normalized)
				if (mediaItem) {
					this.viewerMediaItems = [mediaItem]
					this.viewerMediaIndex = 0
					return
				}
			}

			if (normalized?.pathdoc?.path) {
				this.viewerDocumentItem = normalized
				return
			}

			if (normalized?.file_type === 'forge' || normalized?.forge_file?.translated) {
				this.viewerForgeItem = normalized
				return
			}

			this.$store.globalStore.dispatch('addMessage', {
				message: 'Este archivo no tiene un visor disponible.',
				title: 'Vista previa no disponible',
				created: new Date(),
				type: 'warning',
				icon: 'mdi-eye-off-outline',
				color: '#FB8500'
			})
		},
		closeAttachmentViewer() {
			this.viewerMediaItems = []
			this.viewerMediaIndex = null
			this.viewerDocumentItem = null
			this.viewerForgeItem = null
		},
		minimizeAttachmentViewer(item) {
			if (!item) return
			this.$store.globalStore.commit('addFileToFileManagerHandler', item)
			this.closeAttachmentViewer()
		},
		onViewerError() {
			console.error('Attachment viewer failed to load')
		},
		onViewerLoad() {},
		async openItemMorphable(item) {
			const typeMap = {
				'App\\Models\\TasksRestrictions': 'task',
				'App\\Models\\TasksRestrictionsInteractions': 'task_interaction',
				'App\\Models\\Rdi': 'rdi',
				'App\\Models\\RdiInteractions': 'rdi_interaction',
				'App\\Models\\Additional': 'additional',
				'App\\Models\\AdditionalRevision': 'additional_revision',
				'App\\Models\\AdditionalObservation': 'additional_observation'
			}
			const parentTypesMap = {
				'App\\Models\\TasksRestrictions': 'task',
				'App\\Models\\TasksRestrictionsInteractions': 'task',
				'App\\Models\\Rdi': 'rdi',
				'App\\Models\\RdiInteractions': 'rdi',
				'App\\Models\\Additional': 'additional',
				'App\\Models\\AdditionalRevision': 'additional',
				'App\\Models\\AdditionalObservation': 'additional'
			}
			if (!item || !typeMap[item.morphable_type] || !item.morphable_id) return

			const parentType = parentTypesMap[item.morphable_type]
			const data = {
				item_id: item.morphable_id,
				item_type: typeMap[item.morphable_type]
			}

			if (parentType === 'task') {
				this.$store.consultasStore.commit('setCurrentTarea', { loading: true })
			} else if (parentType === 'rdi') {
				this.$store.rdiStore.commit('setCurrentRDI', { loading: true })
			} else if (parentType === 'additional') {
				this.$store.adicionalesStore.commit('setCurrentAdicional', { loading: true })
			}

			this.closeAttachmentViewer()
			const element = await getParentElement(data)
			if (element.code !== 200) return

			if (parentType === 'task') {
				this.$store.consultasStore.commit('setCurrentTarea', element.task)
			} else if (parentType === 'rdi') {
				this.$store.rdiStore.commit('setCurrentRDI', element.rdi)
			} else if (parentType === 'additional') {
				this.$store.adicionalesStore.commit('setCurrentAdicional', element.additional)
			}
		},
		onButtonClick() {
			this.$refs.uploader.click()
		},
		async onFileChanged(e) {
			const newFile = e.target.files[0]
			if (newFile) {
				this.files_new.push(newFile)
			}
			// Reset input
			this.$refs.uploader.value = null
		},
		removeAttachment(index) {
			this.files_new.splice(index, 1)
		},
		cancelForm() {
			this.files_new = []
		},
		generateUUID() {
			return uuidv4()
		},
		async sendFiles() {
			if (this.files_new.length === 0) {
				this.setMessage({
					message: 'Por favor selecciona al menos un archivo',
					title: 'Sin Archivos',
					type: 'warning',
					icon: 'mdi-alert-circle',
					color: '#fb8c00'
				})
				return
			}

			this.loading = true

			try {
				const biggerFiles = []

				this.files_new.forEach((file) => {
					biggerFiles.push({
						type: 11,
						payload: null,
						description: 'Archivo adjunto',
						total: file.size,
						uuid: this.generateUUID(),
						file,
						attach_files: false
					})
				})

				if (biggerFiles.length > 0) {
					biggerFiles.forEach(file => {
						file.agps_id = this.item.id
						file.payload = {
							agps_id: this.item.id,
							from_file_upload_to_ps: true,
							project_id: this.$store.projectsStore.state.selectedProject.id
						}
						this.$store.globalStore.commit('setFilesToUploadCenter', file)
					})
				}
				this.cancelForm()
			} catch (error) {
				console.error('Error uploading files:', error)
				this.setMessage({
					message: 'Error al cargar los archivos',
					title: 'Error',
					type: 'error',
					icon: 'mdi-alert-circle',
					color: 'red'
				})
			}

			this.loading = false
		},
		async downloadAttachments(attachments){
			this.loadingFilePath = true
			const toZip = attachments
			const files = await getZippedFiles({files_to_zip: toZip, file_name: `Adjuntos-EP-${this.item.originalIndex + 1}.zip`})
			if(files.code == 200){
				window.open(files.fileurl);
			}
			this.loadingFilePath = false
		},
		setMessage(messageData) {
			const data = {
				message: messageData.message,
				title: messageData.title,
				created: new Date(),
				type: messageData.type,
				icon: messageData.icon,
				color: messageData.color,
			}
			this.$store.globalStore.dispatch('addMessage', data)
		}
	}
}
</script>

<style scoped>
	.file-item {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 0px;
	}

	.file-name-truncate {
		max-width: 100px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		display: inline-block;
		font-size: 0.75rem;
	}

	.file-btn:hover {
		background-color: #cfe0ff !important;
	}
</style>